export default "__VITE_ASSET__D$uMYI2z__"